import { httpClient } from '@/modules/common/services/http/http-client';
import { IHomeButtonsV2 } from './types';

export const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_CONSOLIDATION_URL}/consolidation`
});

export function getButtonsV2(): Promise<IHomeButtonsV2 | void> {
  return http.get('/v2/home/buttons/my-account');
}
